document.addEventListener('DOMContentLoaded', function() {
                
}); 

window.addEventListener('load', function() {
 moveModal();
 addModalOpenListeners();
 addModalCloseListeners();
 addModalOverlayCloseListeners();
 addProductToCart();
  checkVariant();
});


function moveModal() {
const modals = document.querySelectorAll('.modal');
modals.forEach((modal) => {
  document.body.appendChild(modal);
});
  console.log("movendo modais")

}

function addModalOpenListeners() {
  console.log('addModalOpenListeners');
  document.querySelectorAll('.add-to-cart-button').forEach(function(button) {
    if (button.getAttribute('data-listener-added') !== 'true') {
      button.addEventListener('click', function() {
        const modalId = button.getAttribute('data-modal-id');
        const modal = document.querySelector('.modal[data-modal-id="' + modalId + '"]');
        modal.style.display = 'block';

      });
      button.setAttribute('data-listener-added', 'true');
    }
  });
}

function addModalCloseListeners() {
console.log('addModalCloseListeners');
  document.querySelectorAll('.close').forEach(function(button) {
    if (button.getAttribute('data-listener-added') !== 'true') {
      button.addEventListener('click', function() {
        const modal = button.closest('.modal');
         setTimeout(function() {
            modal.style.display = 'none';
           upsellId= null;
          }, 50); // Executa a ação após 100 milissegundos

      });
      button.setAttribute('data-listener-added', 'true');
    }
  });
}

function addModalOverlayCloseListeners() {
  console.log('addModalOverlayCloseListeners');
  document.querySelectorAll('.modal').forEach(function(modal) {
    if (modal.getAttribute('data-listener-added') !== 'true') {
      modal.addEventListener('click', function(event) {
        if (event.target === modal) { // Verifica se o clique foi diretamente no overlay e não no conteúdo
          setTimeout(function() {
            modal.style.display = 'none';
          }, 50); // Executa a ação após 100 milissegundos
        }
      });
      modal.setAttribute('data-listener-added', 'true');
    }
  });
}

function initializeModalListeners() {
  moveModal();
  addModalOpenListeners();
  addModalCloseListeners();
  addModalOverlayCloseListeners();

}
var upsellId = null;
function addProductToCart() {
  console.log("addProductToCart upsell")

  document.querySelectorAll('.add_to_cart2').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault(); // Prevenir o envio padrão do formulário
      if (upsellId === null) {
        // Atribui o valor de data-product a upsellId
        upsellId = event.currentTarget.getAttribute('data-firstVariant');
        console.log(upsellId);
      }

      var formData = {
        'items': [
          {
            'id': upsellId,
            'quantity': 1
          },
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 422) {
            // Houve algum erro ao adicionar o produto ao carrinho.
            console.error("Erro ao adicionar o produto ao carrinho:", data.message);
          } else {
            // Produto adicionado com sucesso. Aqui você pode, por exemplo, atualizar um contador de itens no carrinho ou mostrar uma mensagem.
            console.log("Produto adicionado com sucesso!", data);
            // Por exemplo, fechar o modal após adicionar o produto:
            const modal = form.closest('.modal');
            if(modal){
              modal.style.display = 'none';
            }else {
              openAddToCartConfirmation(); 
            }
            upsellId = null;
          }
        })
        .catch(error => {
          console.error("Erro de rede ao adicionar o produto:", error);
        });
    });
    upsellId = null;
  });

}

  class CartWatcher2 {
  constructor() {
    if (!CartWatcher2.instance) {
      console.log("nova instancia")
      this.init();
      CartWatcher2.instance = this;
    }else{console.log("instancia antiga")}

    return CartWatcher2.instance;
  }

  async init() {
    // Inicialmente, pegue o estado do carrinho e armazene-o
    this.cartState = await this.fetchCart();
    // Comece a observar as mudanças
    this.observeCartChanges();
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    const data = await response.json();
    return data;
  }

  emitCartChanges(newCart) {
    // Comparar newCart com this.cartState e emitir eventos se necessário
    // Atualize this.cartState para ser o newCart
    this.cartState = newCart;
    
    const event = new CustomEvent('cart_changed2', { detail: newCart });
    window.dispatchEvent(event);
  }

  observeCartChanges() {
    if (this.cartObserver) {
  this.cartObserver.disconnect();
}
    this.cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);

        if (isValidRequestType && isCartChangeRequest) {
          this.fetchCart().then(newCart => {
            this.emitCartChanges(newCart);
          });
        }
      });
    });

    this.cartObserver.observe({ entryTypes: ['resource'] });
  }
}

// Criação da instância
const cartWatcher2 = new CartWatcher2();

  window.addEventListener('cart_changed2', (e) => {
    console.log('O carrinho mudou:', e.detail);
;
                        setTimeout(function () {
          document.dispatchEvent(new CustomEvent("cart:build"));
      }, 400);

      setTimeout(function () {
          initializeModalListeners();
      }, 800);
    
      setTimeout(function () {
          addProductToCart();
          checkVariant();
      }, 1200);
    

  });


// Função atualizada para alterar o preço
function changePrice(newPrice,newImageUrl, buttonElement) {
    // A partir do botão, encontra o formulário pai
    var formElement = buttonElement.closest('form');

    // Dentro desse formulário, seleciona o elemento pelo nome da classe
    var priceElement = formElement.querySelector('.price_upsell-modal');
    var imgElement = formElement.querySelector('.horizontal-product-img img');
    // Atualiza o conteúdo do elemento com o novo preço
    priceElement.textContent = newPrice;
    imgElement.src = newImageUrl;
  
}

function checkVariant() {


  const variantButtons = document.querySelectorAll(".option-button");
  const selectedVariantInput = document.getElementById("selected-variant");

  // Array para armazenar opções selecionadas
  var selectedOptions = [];

  // Seleciona todos os botões de opção dentro do form específico
  var optionButtons = document.querySelectorAll('form .option-button');

    optionButtons.forEach(function(button) {
    button.addEventListener('click', function() {
  const idJson = button.getAttribute('data-product');
      console.log(idJson);
  const variantsDataElement = document.getElementById('variants-data-'+idJson);
  const allVariants = JSON.parse(variantsDataElement.textContent);

      // Pega o index e value da opção clicada
      var optionIndex = this.getAttribute('data-option-index');
      var optionValue = this.getAttribute('data-option-value');

      // Reseta todos os botões com o mesmo data-option-index
      var sameIndexButtons = document.querySelectorAll('form .option-button[data-option-index="' + optionIndex + '"]');
      sameIndexButtons.forEach(function(btn) {
        btn.setAttribute('data-option-selected', "false");
        btn.classList.remove("upsell-option--active");
        
      });

      // Ativa a opção clicada
      this.setAttribute('data-option-selected', "true");
      this.classList.add("upsell-option--active");
console.log(selectedOptions);
      // Atualizar o array de opções selecionadas
      selectedOptions[optionIndex] = optionValue;

      for (let variant of allVariants) {
        // Pegue todas as opções deste variante
        let variantOptions = [];
        let index = 1;
        while (variant['option' + index]) {
          variantOptions.push(variant['option' + index]);
          index++;
        }

        // Compare as opções do variante com as opções selecionadas
        let isMatching = selectedOptions.every((option, idx) => option === variantOptions[idx]);

        if (isMatching) {
          console.log("ID correspondente:", variant.id);
          console.log("preço da variante", variant.price);
          console.log("data variant:", variant.featured_image.src);
   // Chamando a função atualizada para alterar o preço
                    changePrice('R$ ' + (variant.price / 100).toFixed(2),variant.featured_image.src, button); // Passando o botão como segundo argumento

          
          upsellId= variant.id;
          return variant.id;
        }
      }

      return null;
    });
  });
}


  
